import { OrderFilterId } from '@epicuro-next/models/order-book';

import { invoiceFilterCreatedLocale } from '../invoices-page.locale';

export const orderFilterLabelsText = {
  accountIdText: $localize`:orderBook|Translation for Account Filter@@AccountIdFilterName:Account`,
  addressText: $localize`:orderBook|Translation for Address@@AddressFilterName:Address (Ship To)`,
  brandText: $localize`:orderBook|Translation for Brand Filter@@BrandIdFilterName:Brand`,
  categoryText: $localize`:orderBook|Translation for Category Filter@@CategoryFilterName:Category`,
  colorText: $localize`:orderBook|Translation for color Filter@@ColorFilterName:Color`,
  deliveryMonthText: $localize`:orderBook|Translation for DeliveryDate_requested@@DeliveryDate_requestedFilterName:Delivery Month`,
  deliveryYearText: $localize`:orderBook|Translation for DeliveryDate@@DeliveryDateFilterName:Delivery Year`,
  divisionText: $localize`:orderBook|Translation for Division Filter@@DivisionFilterName:Division`,
  genderText: $localize`:orderBook|Translation for gender Filter@@GenderFilterName:Gender`,
  masterCategoryText: $localize`:orderBook|Translation for Master Category Filter@@MasterCategoryFilterName:Category`,
  materialGroupText: $localize`:orderBook|Translation for Material Group Filter@@MaterialGroupFilterName:Product Type`,
  noosText: $localize`:orderBook|Translation for Noos Filter@@NoosFilterName:NOOS`,
  orderStatusText: $localize`:orderBook|Translation for Incoming@@IncomingFilterName:Order Status`,
  orderTypeText: $localize`:orderBook|Translation for OrderType@@OrderTypeFilterName:Order Type`,
  placedPeriodText: $localize`:orderBook|Translation for Date_order@@Date_orderFilterName:Placed Period`,
  subBrandText: $localize`:orderBook|Translation for Sub Brand Filter@@SubBrandIdFilterName:Sub Brand`,
};

export const orderFilterLabels: { [key in OrderFilterId]: string } = {
  [OrderFilterId.Account]: orderFilterLabelsText.accountIdText,
  [OrderFilterId.Address]: orderFilterLabelsText.addressText,
  [OrderFilterId.Brand]: orderFilterLabelsText.brandText,
  [OrderFilterId.Category]: orderFilterLabelsText.categoryText,
  [OrderFilterId.Color]: orderFilterLabelsText.colorText,
  [OrderFilterId.Division]: orderFilterLabelsText.divisionText,
  [OrderFilterId.MasterCategory]: orderFilterLabelsText.masterCategoryText,
  [OrderFilterId.Gender]: orderFilterLabelsText.genderText,
  [OrderFilterId.IsDelivered]: orderFilterLabelsText.orderStatusText,
  [OrderFilterId.isOrderDelivered]: orderFilterLabelsText.orderStatusText,
  [OrderFilterId.Noos]: orderFilterLabelsText.noosText,
  [OrderFilterId.Month]: orderFilterLabelsText.deliveryMonthText,
  [OrderFilterId.OrderType]: orderFilterLabelsText.orderTypeText,
  [OrderFilterId.PlacedDate]: orderFilterLabelsText.placedPeriodText,
  [OrderFilterId.ProductType]: orderFilterLabelsText.materialGroupText,
  [OrderFilterId.SubBrand]: orderFilterLabelsText.subBrandText,
  [OrderFilterId.Year]: orderFilterLabelsText.deliveryYearText,
  [OrderFilterId.InvoiceCreatedDate]: invoiceFilterCreatedLocale,
};

export const orderFilterValuesLabels = {
  orderStatusInbound: $localize`:orderBook|Translation for Incoming filter Inbound value@@InboundIncomingFilterValue:Inbound`,
  orderStatusHistory: $localize`:orderBook|Translation for Incoming filter History value@@HistoryIncomingFilterValue:History`,
  noosTypeTrue: $localize`:orderBook|Translation for Noos filter True value@@orderBookNoosTrueFilterValue:Yes`,
  noosTypeFalse: $localize`:orderBook|Translation for Noos filter False value@@orderBookNoosFalseFilterValue:No`,
  genderMale: $localize`:orderBook|Translation for Gender filter Male value@@orderBookGenderMaleFilterValue:Male`,
  genderFemale: $localize`:orderBook|Translation for Gender filter Female value@@orderBookGenderFemaleFilterValue:Female`,
  genderNeutral: $localize`:orderBook|Translation for Gender filter Neutral value@@orderBookGenderNeutralFilterValue:Neutral`,
};
